import {combineEpics, ofType} from 'redux-observable';
import {map, catchError, switchMap} from 'rxjs/operators';
import {
  REQ_GET_BOOKS,
  resGetBooksSuccess,
  resGetBooksFailure,
  REQ_GET_NEXT_BOOKS,
  resGetNextBooksSuccess,
  resGetNextBooksFailure,
} from 'ducks/books';
import {getBooks$} from 'api';

const reqGetBooks$$ = (action$, store) => {
  return action$.pipe(
    ofType(REQ_GET_BOOKS),
    switchMap(({value}) => {
      const {
        books: {option},
      } = store.value;
      return getBooks$(option, value).pipe(
        map(({data}) => resGetBooksSuccess(data)),
        catchError((err) => [resGetBooksFailure(err)]),
      );
    }),
  );
};

const reqGetNextBooks$$ = (action$, store) => {
  return action$.pipe(
    ofType(REQ_GET_NEXT_BOOKS),
    switchMap(() => {
      const {
        books: {option, searchText, startIndex},
      } = store.value;
      return getBooks$(option, searchText, startIndex, 10).pipe(
        map(({data}) => resGetNextBooksSuccess(data)),
        catchError((err) => [resGetNextBooksFailure(err)]),
      );
    }),
  );
};

export default combineEpics(reqGetBooks$$, reqGetNextBooks$$);
